<div class="section-container">
  <div class="title">{{ 'ORDER_DASHBOARD.ALL_ORDERS' | fallbackTranslate }}</div>
  <div class="list-container">
    <div class="item" *ngFor="let item of items">
      <div class="icon">
        <img
          [src]="item?.image_path"
          alt="item-img"
         (error)="utilService.handleImageError($event, images.DINNER)"

        />
      </div>
      <div class="item-name">{{ item?.item_name }}</div>
      <div class="quantity">x {{ item?.item_quantity }}</div>
    </div>
  </div>
</div>
